import {connect} from 'react-redux';
import {size} from 'lodash';
import {get} from 'lodash';
import {createStructuredSelector} from 'reselect';

import {searchPageSize} from '/constant/data.constant';
import {COACHES_ONLY, FRONTLINE_COACHES} from '/enum/filter.enum';
import {getSearchResults} from '/redux/action/search.action';
import {
  hasSearchInput,
  hasSearchResultsBySearchInput,
  isEndReachedBySearchInput,
  isLoadingBySearchInput,
  searchInput,
  searchResultsBySearchInput,
} from '/redux/selector/search.selector';
import {searchResultsSizeBySearchInput} from '/redux/selector/search.selector';
import {withHOC} from '/util/hoc.util';
import {calculatePageNumber} from '/util/requestParams.util';

import {Footer} from './Footer';

export const FooterConnected = withHOC(
  connect(
    createStructuredSelector({
      hasSearchResults: hasSearchResultsBySearchInput,
      searchResultsSize: searchResultsSizeBySearchInput,
      isLoading: isLoadingBySearchInput,
      searchResults: searchResultsBySearchInput,
      isEndReached: isEndReachedBySearchInput,
      hasSearchInput,
      searchInput,
    }),
    dispatch => ({
      fetchSearchResults: ({
        searchInput,
        pageNumber,
        appendData,
        filterParam,
        searchOnlyInFrontlines,
        searchOnlyInCoaches,
      }: any) =>
        dispatch(
          // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
          getSearchResults({
            searchInput,
            searchOnlyInCoaches,
            searchOnlyInFrontlines,
            pageNumber,
            appendData,
            filterParam,
          }),
        ),
    }),
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      // @ts-expect-error TS(7030): Not all code paths return a value.
      fetchMore: ({recordsParams}: any) => {
        const {
          isLoading,
          isEndReached,
          searchResults,
          searchInput,
          searchResultsSize,
        } = stateProps;
        const filterParam = get(recordsParams, ['filterBy']);

        const searchOnlyInFrontlines = filterParam === FRONTLINE_COACHES;
        const searchOnlyInCoaches = filterParam === COACHES_ONLY;

        if (!isLoading && !isEndReached) {
          return dispatchProps.fetchSearchResults({
            searchInput,
            pageNumber: calculatePageNumber({
              numberOfRecords: size(searchResults),
              pageSize: searchPageSize,
              total: searchResultsSize,
            }),
            appendData: true,
            filterParam,
            searchOnlyInFrontlines,
            searchOnlyInCoaches,
          });
        }
      },
    }),
  ),
)(Footer);
